module.exports = __webpack_public_path__ + "img/logo_usach2.eb5fe225.jpg";